import { PickersDay, pickersDayClasses, PickersDayProps } from '@mui/x-date-pickers'
import React from 'react'

function renderPickerDay(_: Date, __: Date[], pickersDayProps: PickersDayProps<Date>) {
  return (
    <PickersDay
      {...pickersDayProps}
      sx={{
        [`&&.${pickersDayClasses.selected}`]: {
          backgroundColor: '#62c234',
        },
      }}
    />
  )
}

export default renderPickerDay
